
import { defineComponent, computed } from 'vue';
import { Spin } from 'ant-design-vue';

const component = defineComponent({
  name: 'scene-box',
  components: {
    aSpin: Spin,
  },
  props: {
    titleText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    titleLine: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const isShowTitle = computed(() => props.titleText !== '');
    return { props, isShowTitle };
  },
});

export default component;
